import Vue from "vue";
import $ from "jquery";
import { Component } from "vue-property-decorator";
import { EventBus } from "../Controls/EventBus";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import ModalAjoutUpdateJourFerie from "./modalAjoutUpdateJourFerie/modalAjoutUpdateJourFerie";
import { ParametresInstance } from "../Controls/Parameters";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import EventConstants from "../Controls/EventConstants";
import { JourFerieDto } from "../../dto/GenApi.iNotPaie.Dto/JourFerieDto";
import moment from "moment";
import { NotificationServiceInstance } from "../../shared/services/notification.service";

@Component({
	components: {
		ModalAjoutUpdateJourFerie: require("./modalAjoutUpdateJourFerie/modalAjoutUpdateJourFerie.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as JoursFeriesComponent);
			vm.getJoursFeries();
		});
	}
})
export default class JoursFeriesComponent extends Vue {
	public joursFeries: JourFerieDto[] = [];
	public joursFeriesFiltred: JourFerieDto[] = [];

	public currentOrderColumn = "Date";
	public orderingDesc = true;

	public filterName = "";
	public dataReady = false;

	public joursFeriesSelect: number[] = [];
	public filterJoursFeries = 0;

	public codeSociete = "";

	public modalAjoutUpdateJourFerie?: ModalAjoutUpdateJourFerie = undefined;

	public getJoursFeries(): void {
    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
			this.codeSociete = ParametresInstance.societeCourante.Code;
		}

    	ServicesFactoryInstance.JoursFeriesService.getJoursFeries(data => {
    		this.joursFeries = data;
    		this.joursFeriesFiltred = this.joursFeries;
    		this.getClassOfOrder(this.currentOrderColumn, true);
    		this.setDates();
    		this.doFilter();
    		this.dataReady = true;
    	});
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
    	return (columnName == this.currentOrderColumn && this.orderingDesc == desc) ? "active" : "icons";
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;
    	if (this.joursFeriesFiltred != undefined) {
    		this.joursFeriesFiltred.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	public setDates(): void {
    	for (let i = 0; i < this.joursFeries.length; i++) {
    		const annee = parseInt(moment.utc(this.joursFeries[i].Date).format("YYYY"));
    		if (this.joursFeriesSelect.filter(e => e == annee).length == 0) {
				this.joursFeriesSelect.push(annee);
			}
    	}

		if (this.joursFeriesSelect.filter(e => e == moment.utc().year()).length == 1) {
			this.filterJoursFeries = moment.utc().year();
		} else {
			this.filterJoursFeries = this.joursFeriesSelect[this.joursFeriesSelect.length - 1];
		}
	}

	public doFilter(): any {
		this.joursFeriesFiltred = this.joursFeries.filter(s =>
			this.filterJoursFeries == parseInt(moment.utc(s.Date).format("YYYY")) &&
			s.Libelle &&
			s.Libelle.toUpperCase().includes(this.filterName.toUpperCase())
		);

    	this.doOrder();
	}

	public addJourFerie(): void {
    	if (this.modalAjoutUpdateJourFerie == undefined) {
			this.modalAjoutUpdateJourFerie = this.$refs.modalAjoutUpdateJourFerie as ModalAjoutUpdateJourFerie;
		}

    	this.modalAjoutUpdateJourFerie.Init();
    	$("#modalAjoutUpdateJourFerie").modal("show");
	}

	public update(id: number): void {
    	if (this.modalAjoutUpdateJourFerie == undefined) {
			this.modalAjoutUpdateJourFerie = this.$refs.modalAjoutUpdateJourFerie as ModalAjoutUpdateJourFerie;
		}

    	this.modalAjoutUpdateJourFerie.Init(id);

    	$("#modalAjoutUpdateJourFerie").modal("show");
	}

	public deleteJourFerie(id: number): void {
    	const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
			message: "Souhaitez-vous vraiment archiver le jour férié \"" + this.joursFeries.filter(j => j.Id == id)[0].Libelle + "\"?",
    		callBackYes: () => {
    			ServicesFactoryInstance.JoursFeriesService.deleteJourFerie(id, () => {
    				NotificationServiceInstance.SendSuccess("Jour férié supprimé avec succès.");
    				this.getJoursFeries();
    			});
    		}
    	});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}
}



// WEBPACK FOOTER //
// ./src/components/joursFeries/joursFeries.ts